import React__default, { useRef, useEffect } from 'react';
import ReactCodeInput from '@zignaly-open/react-verification-code-input';
import { Layout } from './styles.js';
import { ErrorMessage } from '../../display/ZigAlertMessage/index.js';
import { Box } from '@mui/material';

function InputCode(_a) {
    var fields = _a.fields, loading = _a.loading, onComplete = _a.onComplete, onChange = _a.onChange, _b = _a.autoFocus, autoFocus = _b === void 0 ? false : _b, _c = _a.clearOnError, clearOnError = _c === void 0 ? false : _c, _d = _a.error, error = _d === void 0 ? null : _d, prefixId = _a.prefixId;
    var inputRef = useRef(null);
    useEffect(function () {
        if (inputRef.current) {
            var input_1 = inputRef.current;
            if (input_1.iRefs.length && autoFocus) {
                setTimeout(function () {
                    var _a;
                    (_a = input_1.iRefs[0].current) === null || _a === void 0 ? void 0 : _a.focus();
                }, 300);
            }
        }
    }, [inputRef]);
    useEffect(function () {
        var _a;
        if (error) {
            clearOnError && ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.__clearvalues__());
            onChange === null || onChange === void 0 ? void 0 : onChange("");
        }
    }, [error, clearOnError]);
    return (React__default.createElement(Layout, { error: error || undefined, loading: loading },
        React__default.createElement(Box, { id: prefixId && "".concat(prefixId, "__code-input") },
            React__default.createElement(ReactCodeInput, { ref: inputRef, className: "input-box", fields: fields, loading: loading, disabled: loading, autoFocus: autoFocus, onComplete: onComplete, onChange: onChange, placeholder: new Array(fields).fill(" ") })),
        error && React__default.createElement(ErrorMessage, { text: error, id: prefixId && "".concat(prefixId, "__error-message") })));
}

export { InputCode as default };
